export default class StringUtils {
  static truncate(str: string, maxLength = 20): string {
    return str.length > maxLength ? str.slice(0, maxLength - 1) + "…" : str
  }

  static toNumber(str: string): number {
    return parseInt(str)
  }
}
